import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, DialogConfirm } from 'components'
import { toast } from 'react-toastify'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material'
import { cloneDeep } from 'lodash'
import { useSelector } from 'react-redux'
import { submitExtraAutoAnswer } from 'services/apiKYP'
import { formatToCNPJ } from 'brazilian-values'

import styles from './styles'

const initialValues = {
  provided_services: '',
  position_in_the_company: '',
  developed_activities: '',
  company_operate_with_securities: false,
  answer_type: 'partnerships',
}

const initialErrors = {
  provided_services: false,
  position_in_the_company: false,
  developed_activities: false,
}

function PartnershipsForm(props) {
  const { questionData } = props

  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const [formState, setFormState] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const handleValidate = () => {
    const errors = cloneDeep(initialErrors)
    Object.keys(errors).forEach((key) => {
      errors[key] = formState[key] === ''
    })
    setFormErrors(errors)
    return Object.keys(errors).every((key) => errors[key] === false)
  }

  const cleanForm = () => {
    setFormState(initialValues)
    setFormErrors(initialErrors)
  }

  const handleSubmit = async () => {
    if (handleValidate()) {
      setLoading(true)
      submitExtraAutoAnswer(token, questionData.uuid, formState)
        .then(() => {
          toast.success("Resposta enviada com sucesso.")
          cleanForm()
        })
        .catch(() => {
          toast.error('Erro ao enviar respostas, por favor tente novamente')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      toast.error(
        'Há campos obrigatórios vazios. Verifique os campos preenchidos e tente novamente.',
      )
    }
  }

  const handleCleanAction = () => {
    setOpen(false)
    cleanForm()
  }

  const handleFieldChange = (event) => {
    const newFormState = cloneDeep(formState)
    const key = event.target.id
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const handleRadioChange = (event) => {
    const key = event.target.name
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value === 'yes'
    setFormState(newFormState)
  }

  const handleOpenConfirmCleaning = () => {
    setOpen(true)
  }
  
  const handleCloseConfirmCleaning = () => {
    setOpen(false)
  }
  
  return (
    <div className={classes.root}>
      <h2>Participação societária</h2>
      <div className={classes.formWrapper}>
        <div className={classes.subject}>
          <p>
            <span>Nome da empresa: </span>
            {questionData.occurrence.corporate_name}
          </p>
          <p>
            <span>Motivo da ocorrência: </span>
            {questionData.occurrence.cnpj
              ? formatToCNPJ(questionData.occurrence.cnpj)
              : 'N/A'}
          </p>
        </div>
        <TextField
          id="provided_services"
          label="Serviços prestados pela referida pessoa jurídica:"
          onChange={handleFieldChange}
          fullWidth
          value={formState.provided_services}
          error={formErrors.provided_services}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          id="position_in_the_company"
          label="Cargo na empresa:"
          onChange={handleFieldChange}
          fullWidth
          value={formState.position_in_the_company}
          error={formErrors.position_in_the_company}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          id="developed_activities"
          label="Funções/Atividades desempenhadas:"
          onChange={handleFieldChange}
          fullWidth
          value={formState.developed_activities}
          error={formErrors.developed_activities}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <FormControl>
          <FormLabel>
            A empresa realiza operações com valores mobiliários?
          </FormLabel>
          <RadioGroup
            row
            value={formState.company_operate_with_securities ? 'yes' : 'no'}
            name="company_operate_with_securities"
            onChange={handleRadioChange}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Sim" />
            <FormControlLabel value="no" control={<Radio />} label="Não" />
          </RadioGroup>
        </FormControl>
        <div className={classes.buttonsContainer}>
          <Button onClick={handleOpenConfirmCleaning} variant="text">
            Limpar formulário
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Responder
          </Button>
        </div>
      </div>
      <DialogConfirm 
        title='Tem certeza de que deseja limpar este formulário?'
        onConfirm={handleCleanAction}
        onCancel={handleCloseConfirmCleaning}
        open={open}
      >
        Esta ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

PartnershipsForm.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default PartnershipsForm
